import { fustionColorPalette } from "../constant/fusion-color-pallete";

const palette = fustionColorPalette;

export const onLightTextColor = palette["text-primary"]; // "#0062E3" // "blue[700]" //
export const onDarkTextColor = palette["text-inverse-primary"];

export const defaultThemingDark = {
  page: [
    {
      backgroundUrl:
        "https://www.directv.com/dtvassets/global/component-assets/in-page_clup/channel_background.jpg",
      backgroundColor: "#102641",
      theme: "onDark"
    }
  ]
};

export const defaultThemingLight = {
  page: [
    {
      backgroundUrl: "",
      backgroundColor: "neutral100", // fallback color
      theme: "onLight"
    }
  ]
};

export interface ThemeOption {
  theme: "onDark" | "ondark" | "dark" | "onLight" | "onlight" | "light";
  background?: string;
}

export interface IChnlInteractiveThemeUI {
  pageBackgroundUrl?: string;
  pageBackgroundColor?: string;
  headerTextColor?: string;
  subheadingTextColor?: string;
  subheadingLegalTextColor?: string;
  zipCodeModuleMode?: "dark" | "light";
  channelHeaderBackground?: string; // condition added in IconBanner - applicable only for light theme
  category?: {
    textColor?: string;
    mode?: "dark" | "light";
  };
}

export function parseThemeObject(themeFeed: any): IChnlInteractiveThemeUI {
  const [page] = themeFeed.page;
  const normalizeTheme = (theme: string): "dark" | "light" => {
    if (theme === "" || theme === undefined || theme === null) {
      return "dark";
    }
    return ["onlight", "light"].includes(theme?.trim()?.toLowerCase()) ?
      "light" :
      "dark";
  };

  const getThemeText = (theme: string) => {
    if (theme === "" || theme === undefined || theme === null) {
      return onDarkTextColor;
    }
    return normalizeTheme(theme) === "light" ?
      onLightTextColor :
      onDarkTextColor;
  };

  const parseColor = (color: string) => {
    if (color === "" || color === undefined || color === null) {
      return "";
    } else if (palette?.[`${color}`]) {
      return palette?.[`${color}`];
    } else if (
      color?.startsWith("#") ||
      ["rgb", "hsl", "transparent", "none"]?.some(other => color?.toLowerCase()?.includes(other))
    ) {
      return color;
    } // Hex color
    return "";
  };

  try {
    if (!page) {
      throw new Error(
        "Theme isnt provided in the feed. Using default theme instead."
      );
    }
    const themeText = getThemeText(page?.theme);
    const themeMode = normalizeTheme(page?.theme);
    const themeLocal =
      themeMode === "light" ? defaultThemingLight : defaultThemingDark;

    return {
      pageBackgroundUrl:
        page?.backgroundUrl || themeLocal.page[0]?.backgroundUrl,
      pageBackgroundColor: page?.backgroundColor ?
        parseColor(page?.backgroundColor) :
        parseColor(themeLocal.page[0].backgroundColor),
      headerTextColor: themeText,
      subheadingTextColor: themeText,
      subheadingLegalTextColor: themeText,
      zipCodeModuleMode: themeMode,
      channelHeaderBackground: page.channelHeaderBackground || "#ECF3FB",
      category: {
        textColor: themeText,
        mode: themeMode
      }
    };
  } catch (error) {
    console.error("[ChnlListingPage] ERROR parsing theme object:", error);
    return parseThemeObject(defaultThemingLight);
  }
}
